import styled from 'styled-components';
import { Box } from '@rebass/grid';

export const AffectedComponents = styled.div`
  margin: 24px 0;
  & > #name {
    margin-bottom: 12px;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
    color: #12344d;
    opacity: 0.8;
  }
  #list {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    #chip {
      margin-right: 4px;
      margin-bottom: 4px;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: #12344d;
      background: #eff4fa;
      border: 1px solid #cfd7df;
      box-sizing: border-box;
      border-radius: 4px;
      padding: 6px 10px;
      display: flex;
      align-items: center;
      width: fit-content;
      white-space: nowrap;
      & :first-child {
        margin-right: 6px;
        margin-top: 1px;
      }
    }
  }
  .group-name {
    font-weight: 500;
    font-size: 14px;
    display: block;
    padding-right: 4px;
    color: #0b0d11;
    margin-bottom: 4px;
  }
  .sub-group-name {
    margin-bottom: 4px;
    padding-right: 4px;
    font-size: 14px;
  }
`;
export const CardWrapper = styled(Box)`
  color: #12344d;
  line-height: 1.5;
  overflow: auto;
  max-height: 80vh;

  .breadcrump {
    font-size: 15px;
    line-height: 1.4;
    /* text-transform: capitalize; */
    font-weight: bold;
    margin-bottom: 30px;

    span.arrow {
      margin: 0 5px;
    }

    span.home {
      font-weight: 400;
      opacity: 0.6;
    }
  }

  .timestamp {
    font-size: 12px;
    color: #0a273c;
    opacity: 0.7;
  }

  .section-title {
    opacity: 0.8;
    font-weight: 500;
  }

  .components-affected {
    display: flex;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.8;
    color: #12344d;
    letter-spacing: 0.15px;
  }
  .description {
    font-size: 14px;
  }
`;
